import * as amplitude from '@amplitude/analytics-browser';
import config from 'src/config';
import { track, identify } from '@amplitude/analytics-browser';

const PREPROD = 'preprod';
const PRODUCTION = 'production';

const ENVIRONMENTS_TO_LOG = new Set([PREPROD, PRODUCTION]);

const camelCaseToCapitalize = (str) =>
    str.replace(/[A-Z]/g, (letter, index) =>
        index === 0 ? letter.toLowerCase() : ` ${letter.toLowerCase()}`
    );

export const isVerifyEnv = (env) => {
    if (!env) return '';
    const regexParams = /@@(.*?)@@/;
    return !regexParams.test(env);
};
const verifyAmplitudeKey = () =>
    Boolean(config.amplitude) &&
    isVerifyEnv(config.amplitude);

const verifyEnvironment = () => {
    return ENVIRONMENTS_TO_LOG.has(config.environment);
}

export const initAmplitude = async (email: string) => {
    if (!verifyAmplitudeKey()) return;
    amplitude.init(config.amplitude, email);
};

export const resetAmplitude = () => {
    if (!verifyAmplitudeKey()) return;
    amplitude.reset();
};

const formatCapitalizedParams = (params) => {
    if (!params) return { environment: config.environment };
    const formattedParams = {};
    Object.entries(params).forEach(([paramKey, paramValue]) => {
        const newKey = camelCaseToCapitalize(paramKey);
        formattedParams[newKey] = paramValue;
    });
    return { environment: config.environment, ...formattedParams };
};

const logEvent = async (eventName: string, properties?: Record<string, any>) => {
    console.log(`Launch amplitude event "${eventName}" with properties: `, (properties ?? ""));
    if (!verifyAmplitudeKey() || !verifyEnvironment()) return;
    const eventProperties = formatCapitalizedParams(properties)
    await track(eventName, eventProperties).promise;
}

const setUserProperties = (userProperties: { key: string, value: any }[]) => {
    const identifyEvent = new amplitude.Identify();
    userProperties.forEach(({ key, value }) => {
        identifyEvent.setOnce(key, value);

    })

    identify(identifyEvent);
}

export default { logEvent, formatCapitalizedParams, setUserProperties };
